import { createContext, useEffect, useMemo } from "react";
import { FitnessApps } from "@WahooFitness/cloud-client-ts";
import { FitnessAppType } from "@WahooFitness/cloud-client-types";
import { useCloudContext, useConfigContext, useOfflineSWR } from "@WahooFitness/wahoo-offline-mfe";
import useConnectedApps from "@/hooks/useConnectedApps";

interface IFitnessAppsContextProps {
  fitnessApps: FitnessAppType[];
}

export const FitnessAppsContext = createContext<IFitnessAppsContextProps>({
  fitnessApps: [],
});

export const FitnessAppsContextProvider = ({ children }: any) => {
  const { getCloudClient } = useCloudContext();
  const { wahooToken } = useConfigContext();
  const fitnessAppsClient = useMemo(() => getCloudClient(FitnessApps), [getCloudClient]);

  const {
    data: fitnessAppData,
    // _error: fitnessAppDataError,
    // _isLoading: fitnessAppDataIsLoading,
  } = useOfflineSWR(
    ["fitnessApps", wahooToken],
    ([_key, token]) => fitnessAppsClient.getAll(token),
    { focusThrottleInterval: 60000, dedupingInterval: 60000 }
  );

  const { connectedAppsData, refreshConnectedApp } = useConnectedApps(true);

  useEffect(() => {
    const asyncRefresh = async () => {
      if (connectedAppsData) {
        const TPApp = connectedAppsData?.find((app) => app.name === "TrainingPeaks");
        if (TPApp?.id && TPApp?.connected_app_user?.import_plans === true) {
          try {
            await refreshConnectedApp(TPApp.id);
          } catch (err: any) {
            if (!(err.status && (err.status.toString().startsWith("5") || err.status === 429))) {
              throw err; // report unexpected errors to bear hug
            }
          }
        }
      }
    };
    asyncRefresh();
  }, [connectedAppsData, refreshConnectedApp]);

  return (
    <FitnessAppsContext.Provider
      value={{
        fitnessApps: fitnessAppData || [],
      }}
    >
      {children}
    </FitnessAppsContext.Provider>
  );
};
